import React, { Fragment, useEffect, useState } from "react"
import { useSelector } from 'react-redux'
import { connect } from "react-redux"
import MetaTags from 'react-meta-tags';
import { Row, Col, Card, CardBody, CardTitle, CardSubtitle, Button } from "reactstrap"
// import { MapMarker, Map } from "react-kakao-maps-sdk";
import { Roadview } from "react-kakao-maps-sdk";
import Modal from "components/RopikCustom/Modal";

//FireBase
import firebase from 'firebase/compat/app'
import { initializeApp } from 'firebase/app/dist'
import { getAnalytics } from 'firebase/analytics/dist'
import { getDatabase, ref, onValue, off, set, push, child } from 'firebase/database/dist'
import { firebaseConfig } from "pages/Custom/FirebaseTool"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

import { getCarListAll, getCollectList, tmsCompanyResponse, tmsResponse } from "../../crud/auth.crud"

import moment from 'moment';
import Util from 'pages/Dashboard/Common/Util'

// 이미지
import VWorld from './VWorld'

const initApp = initializeApp(firebaseConfig)
// const analytics = getAnalytics(initApp)

const TMS = () => {
  const currentTime = moment(new Date()).format('YYYY-MM-DD')

  const selector = useSelector(state => state)
  const user = selector.auth?.user;
  const type = user?.type || ""
  const company = user?.member_group?.[0]?.company_group.id
  const [car, setCar] = useState('')
  const [carList, setCarList] = useState([])
  const [date, setDate] = useState(currentTime)
  const [positions, setPositions] = useState([])
  const [lat, setLat] = useState()
  const [lng, setLng] = useState()
  const [collectList, setCollectList] = useState([])
  const [prevData, setPrevData] = useState(null)
  const [firebaseData, setFirebaseData] = useState(null)
  const [roadviewLat, setRoadviewLat] = useState(null)
  const [roadviewLng, setRoadviewLng] = useState(null)
  const [panoId, setPanoId] = useState(null)
  const [modalShow, setModalShow] = useState(false)
  const [coordinateList, setCoordinateList] = useState([])
  const [wasteBinCoordinateList, setWasteBinCoordinateList] = useState([])
  const [mergedCoordinateList, setMergedCoordinateList] = useState([])
  const [dataList, setDataList] = useState([])
  const [page, setPage] = useState(1);
  const [isLoading1, setIsLoading1] = useState(false);
  const [isLoading2, setIsLoading2] = useState(false);
  const [qtySum, setQtySum] = useState(0)

  const modalClose = () => {
    setModalShow(false)
    setRoadviewLat(null)
    setRoadviewLng(null)
  }

  const getCompanyDataList = async () => {
    if (isLoading1) {
      return;
    }
    setIsLoading1(true)
    try {
      let carId = ''
      if (carList.length > 0 && car) {
        carId = carList?.find(v => v.number === car)?.id || ''
      }
      let newDate = moment(new Date()).format('YYYY-MM-DD')
      let tomorrow = moment(new Date()).add(1, 'days').format('YYYY-MM-DD');
      const params = {
        driver_company: company,
        company_name: '',
        collect_zone: '',
        car: carId,
        driver: '',
        start_date: date || newDate,
        end_date: tomorrow,
        page: page,
      }
      const response = await getCollectList(params);
      if (response.status === 200) {
        const content = response.data?.data || [];
        const sortedContent = content.sort((a, b) => {
          if (a.state === 'Y' && b.state !== 'Y') return 1
          if (a.state !== 'Y' && b.state === 'Y') return -1
          return 0
        });
        const wasteBinCoordinates = sortedContent.flatMap((content) => {
          const firstBin = content.waste_bin_collect?.[0];
          return firstBin
            ? [{
                coordinate: [parseFloat(firstBin?.y), parseFloat(firstBin?.x)],
                companyName: content?.company?.name,
                address: `${content?.company?.address1} ${content?.company?.address2 ?? ''}`,
                collectionDate: firstBin?.collect_date,
                state: content?.state,
              }]
            : [];
        });
        setWasteBinCoordinateList(wasteBinCoordinates);
        const qtySum = sortedContent.reduce((sum, item) => sum + item.qty, 0);
        setQtySum(qtySum)
        setDataList(sortedContent)
      }
      setIsLoading1(false)
    } catch (error) {
      console.error(error);
      setIsLoading1(false)
    }
  };

  useEffect(() => {
    if (!isLoading1 && !isLoading2) {
      setMergedCoordinateList([...coordinateList, ...wasteBinCoordinateList])
    }
  }, [coordinateList, wasteBinCoordinateList, isLoading1, isLoading2])

  const getDataList = async () => {
    if (isLoading2) {
      return;
    }
    setIsLoading2(true)
    try {
      let carId = 'A'
      if (carList.length > 0 && car) {
        carId = carList?.find(v => v.number === car)?.id || 'A'
      }
      let params = {
        company: company,
        date: date + ' 00:00:00',
        car: carId
      }
      if (type === 'emitter') {
        const param = {
          company: company,
        }
        const response = await tmsCompanyResponse(param.company)
        params = {
          company: response.data?.data?.[0]?.company,
          date: date + ' 00:00:00',
          car: carId
        }
      }
      const rs = await tmsResponse(params)
      const tmp = []
      const tmp2 = []
      const coordinates = []
      if (rs.data?.result === 'success') {
        for (let i = 0; i < rs.data?.data.length; i++) {
          let data = rs.data?.data[i];
          if ([5, 50, 100, 150].includes(i)) {
          }
          const parsedX = parseFloat(data.x)
          const parsedY = parseFloat(data.y)
          let item = {
            lat: parsedX,
            lng: parsedY,
            markerName: data.id + ''
          }
          coordinates.push({
            coordinate: [parsedX, parsedY],
            companyName: data?.target_company_data?.name,
            address: `${data?.target_company_data?.address1} ${data?.target_company_data?.address2}`,
            collectionDate: data?.created_at?.split("T")[0],
            state: 'Y'
          })
          tmp.push(item)
          let list = { company: data.company_data.name, create: data.created_at.substr(11, 8) }
          tmp2.push(list)
        }
      }
      setCoordinateList(coordinates)
      setCollectList(tmp2)
      if (tmp.length > 0) {
        getPositionList(tmp)
      }
      setIsLoading2(false)
    } catch (error) {
      console.error(error);
      setIsLoading2(false)
    }
  }

  const getPositionList = (tmp) => {
    let arr = []
    let latSum = 0
    let lngSum = 0
    for (let i = 0; i < tmp.length; i++) {
      let val = tmp[i]
      arr.push({ title: val.markerName, latlng: { lat: val.lng, lng: val.lat } })
      latSum += val.lng
      lngSum += val.lat
    }
    setPositions(arr)
    setLat(latSum / tmp.length)
    setLng(lngSum / tmp.length)
  }

  const openRoadView = (geometry) => {
    setRoadviewLng(geometry[0])
    setRoadviewLat(geometry[1])
  }

  const getCarDataList = async () => {
    let params = {
      company: company,
    }
    const response = await getCarListAll(params.company)
    if (response.data?.result === 'success') {
      setCarList(response.data?.data)
    }
  }

  useEffect(() => {
    if (roadviewLat && roadviewLng) {
      const client = new window.kakao.maps.RoadviewClient()
      const position = new window.kakao.maps.LatLng(roadviewLat, roadviewLng)
      client.getNearestPanoId(position, 50, (panoId) => {
        setPanoId(panoId)
        setModalShow(true)
      })
    }
  }, [roadviewLat, roadviewLng])

  // useEffect(() => {
  //   const today = new Date().toISOString().split("T")[0];

  //   const db = getDatabase(initApp)
  //   const dbRef = ref(db, 'waste_collect/tms')
  //   const onDataChanged = (snapshot) => {
  //     const newData = snapshot.val();
  //     setPrevData(firebaseData)
  //     setFirebaseData(newData);
  //   }

  //   if (date === today) {
  //     onValue(dbRef, onDataChanged);
  //   } else {
  //     off(dbRef, "value", onDataChanged);
  //   }
  //   return () => {
  //     off(dbRef, 'value', onDataChanged)
  //   }
  // }, [date])

  useEffect(() => {

    const db = getDatabase(initApp)
    const dbRef = ref(db, 'waste_collect/tms')
    const onDataChanged = (snapshot) => {
      const newData = snapshot.val();
      setPrevData(firebaseData)
      setFirebaseData(newData);
    }

    onValue(dbRef, onDataChanged)
    return () => {
      off(dbRef, 'value', onDataChanged)
    }
  }, [date])

  useEffect(() => {
    getCompanyDataList()
    getDataList()
  }, [firebaseData])

  useEffect(() => {
    getCarDataList()
  }, []);

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>수거현황(TMS) | 웨이스트버스</title>
        </MetaTags>
        <div className="container-fluid">
          <Breadcrumbs title="홈" breadcrumbItem="" breadcrumbHeaderItem='수거현황(TMS)' />

          <div className="d-flex w-100 gap-30 align-items-center mb-3">
            <div className="email-rightbar flex-grow-1">
              <Card className="mb-0">
                <CardBody className="padding-0">
                  <table className="input-table">
                    <tbody>
                      <tr>
                        <td className="col-10 padding-left-8 primary-bg white-text font-size-12">차량선택</td>
                        <td className="col-20">
                          <select className='waver-select-box w-100 border-radius-0' value={car} onChange={(e) => {
                            setCar(e.target.value)
                          }}>
                            <option value="" disabled hidden>{'차량을 선택하세요.'}</option>
                            {carList.map((item, index) => (
                              <option key={'tms_car_list_' + index} value={item.number}>{item.number}</option>
                            ))}
                          </select>
                        </td>
                        {/* <td className="col-10 padding-left-8 primary-bg white-text font-size-12">날짜 선택</td>
                        <td className="col-20">
                          <input className="waver-input-box border-radius-0 w-100 margin-right-4" type="date" value={date} onChange={(e) => {
                            setDate(e.target.value);
                          }} />
                        </td> */}
                        <td className="col-10 padding-left-8 primary-bg white-text font-size-12"></td>
                        <td className="col-20"></td>
                      </tr>
                    </tbody>
                  </table>
                </CardBody>
              </Card>
            </div>
            <div className="d-flex flex-direction-column align-items-end">
              <button type="button" className="custom-btn btn-dark-gradient border-radius-0 white-text border-none margin-right-0" onClick={() => {
                getDataList()
                getCompanyDataList()
              }}>
                검색
              </button>
            </div>
          </div>
          <Row>
            <Col lg={6} style={{ margin: '0px auto' }}>
              <Card>
                <CardBody>
                  <div id="gmaps-markers">
                    <VWorld coordinateList={mergedCoordinateList} openRoadView={(e) => openRoadView(e)} isLoading={isLoading1 || isLoading2} />
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col lg={6} style={{ margin: '0px auto' }}>
              <Card>
                <CardBody style={{ padding: 0, borderRadius: 4, overflow: 'hidden' }}>
                  <div className="table-responsive" style={{ maxHeight: 'calc(100vh - 265px)', overflowY: 'auto' }}>
                    <table className="table table-hover table-centered table-nowrap mb-0 chart-table">
                      <thead className="chart-thead">
                        <tr>
                          <th scope="col">총 수거 스케줄 / 완료</th>
                          <th scope="col">총 수거 물량(ℓ)</th>
                        </tr>
                      </thead>
                      <tbody className="chart-tbody">
                        <tr>
                          <td>{Util.setCommaPrice(dataList.length)} / {Util.setCommaPrice(dataList.filter(v => v.state === 'Y').length)}</td>
                          <td>{Util.setCommaPrice(qtySum)}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </CardBody>
              </Card>

              <div className="d-flex justify-content-between align-items-center mb-2">
                <p className="mb-0 font-size-16"><span className="font-weight-bold">스케줄 목록</span> [ 건수 : {dataList.length}건 ]</p>
              </div>
              <Card>
                <CardBody style={{ padding: 0, borderRadius: 4, overflow: 'hidden' }}>
                  <div className="table-responsive" style={{ maxHeight: 'calc(100vh - 265px)', overflowY: 'auto' }}>
                    <table className="table table-hover table-centered table-nowrap mb-0 chart-table">
                      <thead className="chart-thead">
                        <tr>
                          <th scope="col">차량번호</th>
                          <th scope="col">운반기사</th>
                          <th scope="col">가맹점 명</th>
                          <th scope="col">수거구역</th>
                          <th scope="col">수거현황</th>
                        </tr>
                      </thead>
                      <tbody className="chart-tbody">
                        {dataList.map((item, index) => {
                          const isDone = item.state === 'Y'
                          return (
                            <tr key={item.id + '_' + index}>
                              <td style={{ backgroundColor: isDone ? 'rgba(11, 57, 62, 0.1)' : 'white' }}>{item?.car?.number || ''}</td>
                              <td style={{ backgroundColor: isDone ? 'rgba(11, 57, 62, 0.1)' : 'white' }}>{item?.member?.username || ''}</td>
                              <td style={{ backgroundColor: isDone ? 'rgba(11, 57, 62, 0.1)' : 'white' }}>{item?.company?.name || ''}</td>
                              <td style={{ backgroundColor: isDone ? 'rgba(11, 57, 62, 0.1)' : 'white' }}>{item?.company?.address1 + ' ' + item?.company?.address2}</td>
                              <td style={{ backgroundColor: isDone ? 'rgba(11, 57, 62, 0.1)' : 'white', fontWeight: isDone ? 'bold' : 'normal' }}>{isDone ? '완료' : '미완료'}</td>
                            </tr>
                          )
                        })
                        }
                        {!dataList &&
                          <tr>
                            <td scope="row" colSpan="14">데이터가 없습니다.</td>
                          </tr>
                        }

                      </tbody>
                    </table>
                  </div>

                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
      <Modal title={'로드뷰'} show={modalShow} onHide={modalClose} size="lg">
        <Roadview
          panoId={panoId}
          position={{
            lat: roadviewLat,
            lng: roadviewLng,
            radius: 50
          }}
          style={{ width: "100%", height: "480px", marginTop: "1rem" }}
        />
      </Modal>
    </React.Fragment>
  )
}

export default TMS